
<script>
	import listBase from '@_system/components/base/list.vue'
	import footerIndex from './footer/index.vue'
	import vouchercodeIndex from './lib/vouchercode/index.vue'
	export default {
		extends: listBase,
		name: 'purchasevoucherIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-switch style="padding-left:20px" v-model={this.showVoucherurgent} onChange={this.voucherurgentChange} active-text="显示催收" inactive-text=""></el-switch>,
			]
			this.$slots.plug = [
				<vouchercode-index vouchercode={this.vouchercode} ref="vouchercodeIndex"  />
			]
			this.$slots.footer = [
				<div style="position: relative;width: 100%;height:100%;">
					<footer-index currentRow={this.currentRow} ref="purchasevoucherFooter" onUploadsuccess={this.uploadsuccess} />
				</div>
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				showVoucherurgent:false,
				moduleName: 'purchasevoucher',
				windowName: '采购凭证',
				windowType: 'modal',
				currentRow:null,
				vouchercode:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			synchronous(row){
				this.loading = true
				this.$api.purchasevoucher.synchronous({billCode:row.billCode}).then(()=>{
					this.loading = false
					this.customreload()
				},()=>{
					this.loading = false
				})
			},
			uploadsuccess(e){
				if(e.action == 'signature' && e.vouchercode){
					this.vouchercode = e.vouchercode
					this.$refs.vouchercodeIndex.modal_show()
				}
				this.customreload()
			},
			voucherurgentChange(e){
				this.foreingKey.voucherurgent = e?1:0
				this.customreload()
			},
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field=='storageName'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.voucherurgent==1){
									str.push(<el-tag size="mini" type="danger" effect="dark" style="margin-right: 2px;">催</el-tag>)
								}
								str.push(<span>{row.storageName}</span>)
								return str
							}
						}
					}
				})
				
			},
			beforeRender(){
				this.currentRow = null
			},
			signature(e) {
				this.$confirm('是否确认签章?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.purchasevoucher.updatefromlist(0,{
						id:e.id,
						signature:1
					}).then((res)=>{
						if(res.action == 'signature' && res.vouchercode){
							this.vouchercode = res.vouchercode
							this.$refs.vouchercodeIndex.modal_show()
						}
						this.customreload()
						this.$message.success('操作成功')
					})
					
				}).catch(() => {

				})
			},
			backsignature(e) {
				this.$confirm('是否确认反签章?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.purchasevoucher.updatefromlist(0,{
						id:e.id,
						signature:0
					}).then(()=>{
						this.customreload()
						this.$message.success('操作成功')
					})
					
				}).catch(() => {
			
				})
			},
			cellClick(e) {
				if (e.column.field) {
					this.currentRow = e.row
				}
				
			},
			cellStyle({
				row,
				column
			}) {
				let map = {
					status:{
						1:'#F56C6C',
						2:'#409EFF',
						3:'#67C23A',
					}
				}
				if(map[column.field]){
					return {
						color: map[column.field][row[column.field]]
					}
				}
			},
		},
		components: {
			footerIndex,
			vouchercodeIndex
		}
	}
</script>
